<template>
  <CardedDisplay>
    <PlainDisplay icon="mdi-eye" :show_icon="false" :title="''" cmp_class="">
      <v-icon>mdi-hash</v-icon>
      {{
        (is_owner && is_in_admin_view == false && is_in_public_view == false) 
          ? "Hash tags improve your business search results, users will easily find your business "
          : "Company hash tags"
      }}
      <div class="pa-5 white">
        <v-chip
          v-for="(tag, index) in display_hash_tags"
          :key="index"
          :close="is_owner"
          color="green"
          @click:close="remove_tag(tag, index)"
          class="white--text mr-2 ml-2"
        >#{{tag}}</v-chip>
      </div>
      <CardedForm
        ref="tags_business_form_ref"
        id="tags_business_form"
        title="Use this form to add a hash tag"
        :is_loading="is_loading || is_in_admin_view == true || is_in_public_view == true"
        @on-submit-form="submit"
        :errors="errors"
        :message="message"
        @on-auto-fill="on_auto_fill"
        @on-close-message="on_hide_message"
        @on-clear-form="on_form_cleared"
        v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
        cmp_class="elevation-4 pt-2"
      >
        <h5 class="info--text">
          Enter something about your business e.g <b>Fast_Cars, V8 Engine</b>
        </h5>
        <h5 class="info--text"  >Separate each entry with a comma.</h5>
        <h5 class="warning--text">
          You can only have upto a maximum of
          {{ page_info.maximum_hash_tags }} hash tags
        </h5>
        <TextField
          v-model="form.tag"
          :validation_rules="form_rules.tag"
          label="Enter Something"
          icon="mdi-pen-plus"
          :disabled="is_loading  || is_in_admin_view == true"
        ></TextField>
      </CardedForm>
    </PlainDisplay>
  </CardedDisplay>
</template>

<script>
import ServerClient from "../lib/ServerClient";
import Utils from "../lib/Utils";
import page_info from "../lib/page_info";
import BusinessViewHeader from "../components/BusinessViewHeader";
import CardedSectionHeader from "../components/CardedSectionHeader";
import CardedForm from "../components/CardedForm";
import PlainDisplay from "../components/PlainDisplay";
import CardedDisplay from "../components/CardedDisplay";
import TextField from "../components/TextField";
export default {
  name: "BusinessViewHashTags",
  components: {
    CardedForm,
    PlainDisplay,
    CardedDisplay,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    user: {
      type: Object,
      default: function () {
        return null;
      },
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      errors: [],
      message: "",
      form: {
        tag: "",
      },
      form_rules: {
        tag: [
          Utils.validate.is_required(
            "Please type something connected to your line of business"
          ),
          Utils.validate.min_max_length(
            3,
            100,
            "Your entry should be between 3 and 100 characters long"
          ),
        ],
      },
      page_info: page_info,
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 6);
      var rnd2 = Math.ceil(Math.random() * 6);
      this.form.tag = "cool tag " + rnd + ", some thing nice " + rnd2;
      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.form.tag = "";
      this.errors = [];
      this.message = "";
      this.$refs.tags_business_form_ref.on_clear_form();
    },
    on_form_cleared() {
      //this.init_form();
    },
    get_clean_tags_list(source_str) {
      var tags_list = [];
      if (source_str && source_str != null) {
        var temp_parts = source_str.replace("#","").trim().split(",");
        for (var index = 0; index < temp_parts.length; index++) {
          var part = temp_parts[index];
          part = part.trim().toLowerCase();
          if (part.length > 0) {
            tags_list.push(part);
          }
        }
      }
      return tags_list;
    },
    get_new_tag_value(skip_form_tags) {
      var old_tags_list = this.get_clean_tags_list(this.business.tags);
      var new_tags_list = this.get_clean_tags_list(this.form.tag);
      var new_tag_value = "";
      for (var index = 0; index < new_tags_list.length && skip_form_tags == false; index++) {
        var tag_list_item = new_tags_list[index];
        if (old_tags_list.indexOf(tag_list_item) < 0) {
          if (new_tag_value.length > 0) {
            new_tag_value = new_tag_value + ", ";
          }
          new_tag_value = new_tag_value + tag_list_item;
        }
      }
      for (var index = 0; index < old_tags_list.length; index++) {
        var tag_list_item = old_tags_list[index];
        if(skip_form_tags == true && new_tags_list.indexOf(tag_list_item) > -1){
            continue; //skip this entry
        }
        if (new_tag_value.length > 0) {
          new_tag_value = new_tag_value + ", ";
        }
        new_tag_value = new_tag_value + tag_list_item;
      }
      return new_tag_value;
    },
    submit() {
      var new_tag_value = this.get_new_tag_value(false);
      this.send_updated_tag_value(new_tag_value);
    },
    on_hide_message() {
      this.$emit("on-success-tags-updated");
    },
    remove_tag(tag, index) {
        this.form.tag = tag;
        var new_tag_value = this.get_new_tag_value(true);
        this.send_updated_tag_value(new_tag_value);
    },
    send_updated_tag_value(value){
        this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");

      ServerClient.Businesses.update_business_tags(
        {
          tags: value,
          id: this.business.id,
          user_id: this.user_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.init_form();
          this.message =
            "<b>Operation was successfull</b> <br/>  Your search tags have been updated";
          this.$refs.tags_business_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.tags_business_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    }
  },
  computed: {
    display_hash_tags() {
      var list = [];
      if (
        this.business &&
        this.business.tags &&
        this.business.tags != null &&
        this.business.tags.length > 0
      ) {
        var tags = this.business.tags.split(", ");
        for (var index = 0; index < tags.length; index++) {
          var tg = tags[index];
          tg = tg.trim().toLowerCase();
          if (tg.length > 0) {
            list.push(tg);
          }
        }
      }
      return list;
    },
  },
};
</script>